/* eslint-disable max-statements */
import moment from 'moment';
import {filterPriorizationOptions, filterPriorizationVehTypeOptions,
  ordersMapper} from '../constants/filterPriorizationOptions';
import {vehTypeSpecials} from '../constants/selectTypes';
import React from 'react';
import {Form} from 'semantic-ui-react';

export const detectOrderDates = (schedule, open, close, includeColors = true) => {
  if (close) {
    return includeColors ? [close.substring(0, 10), 'priorization-date-color-green'] : close.substring(0, 10);
  } else if (open) {
    return includeColors ? [open.substring(0, 10), 'priorization-date-color-orange'] : open.substring(0, 10);
  } else if (schedule) {
    const diffDays = moment().diff(schedule, 'days');
    return includeColors ?
      [schedule.substring(0, 10), diffDays > 0 ? 'priorization-date-color-red' : 'priorization-date-color-blue'] :
      schedule.substring(0, 10);
  }
  return ['', 'priorization-date-color-grey'];
};

export const getDate = (orderType, line) => {
  let dates = {
    'schedule': null,
    'open': null,
    'close': null,
  };
  if (orderType === 'MOV') {
    dates = {
      'schedule': line.movementScheduledDate,
      'open': null,
      'close': line.movementCloseDate,
    };
  } else if (orderType === 'HU') {
    dates = {
      'schedule': line.hunterScheduledDate,
      'open': null,
      'close': line.hunterCloseDate,
    };
  } else if (orderType === 'ACC') {
    dates = {
      'schedule': line.accessoriesScheduledDate,
      'open': line.accessoriesOpenDate,
      'close': line.accessoriesCloseDate,
    };
  } else if (orderType === 'PDS') {
    dates = {
      'schedule': line.pdsScheduledDate,
      'open': line.pdsOpenDate,
      'close': line.pdsCloseDate,
    };
  }
  const {close, open, schedule} = dates;

  if (close) {
    return close.substring(0, 10);
  } else if (open) {
    return open.substring(0, 10);
  } else if (schedule) {
    return schedule.substring(0, 10);
  }
  return null;
};

export const existOpenOrCloseOrders = (line) => {
  if (
    line.hunterCloseDate ||
    line.accessoriesOpenDate ||
    line.accessoriesCloseDate ||
    line.pdsOpenDate ||
    line.pdsCloseDate
  ) {
    return true;
  }
  return false;
};

export const applyFilters = ({
  filteredData,
  data,
  filters,
  setDropDownOptions,
  setDropDownValue,
  vehTypeFilters,
  setDropDownTypeOptions,
  setDropDownTypeValue,
}) => {
  if (vehTypeFilters) {
    const {vehTypeFilterKey} = vehTypeFilters;
    if (vehTypeFilterKey === 'normal') {
      setDropDownTypeValue(vehTypeFilterKey);
      data = [...data.filter((line) => !vehTypeSpecials.includes(line.vehType))];
    } else if (vehTypeFilterKey === 'specials') {
      setDropDownTypeValue(vehTypeFilterKey);
      data = [...data.filter((line) => vehTypeSpecials.includes(line.vehType))];
    } else {
      setDropDownTypeOptions(filterPriorizationVehTypeOptions);
      setDropDownTypeValue('');
    }
  }
  if (filters) {
    const {filterKey, filterValue} = filters;
    if (filterKey === 'date') {
      setDropDownOptions((options) => [ordersMapper.TODO, ordersMapper[filterValue.orderType]]);
      setDropDownValue(filterValue.orderType);
      return data.filter((line) => {
        const dateLine = getDate(filterValue.orderType, line);
        const dateFilter = filterValue.date && filterValue.date.substring(0, 10);
        return dateLine === dateFilter;
      });
    } else if (filterKey === 'available') {
      return filteredData.filter((line) => {
        return (
          !line.haveOpenCloseOrders &&
          (line.prioritizationDate || line.prioritizationDateMod)
        );
      });
    } else if (filterKey === 'prioritized') {
      setDropDownValue(filterKey);
      return data.filter((line) => line.prioritizationDate);
    } else if (filterKey === 'notPrioritized') {
      setDropDownValue(filterKey);
      return data.filter((line) => !line.prioritizationDate);
    }
    setDropDownOptions(filterPriorizationOptions);
    setDropDownValue('');
    return data;
  }
  return data;
};

export const prepareSelected = (selectedData) => {
  return selectedData.map((line) => ({
    'order': line.order,
    'line': line.line,
    'masterCode': line.masterCode,
    'sfx': line.sfx,
    'model': line.model,
    'chassis': line.chassis,
    'externalColor': line.externalColor,
    'colorName': line.colorName,
    'reservationId': line.reservationId,
    'dealerName': line.dealerName,
  }));
};

export const getMinDate = (dates, position) => {
  const filteredDates = Object.values(dates).slice(0, position).filter((date) => date).map((date) => moment(date));
  return filteredDates.length ? moment.max(filteredDates) : moment();
};

export const getMaxDate = (dates, position) => {
  const filteredDates = Object.values(dates).slice(position + 1).filter((date) => date).map((date) => moment(date));
  return filteredDates.length ? moment.min(filteredDates) : null;
};

export const customValuesVehiclesDates = (key, value, row) => {
  if (key === 'movementScheduledDate') {
    const {movementScheduledDate, movementCloseDate} = row;
    return detectOrderDates(movementScheduledDate, null, movementCloseDate, false);
  }
  if (key === 'hunterScheduledDate') {
    const {hunterScheduledDate, hunterCloseDate} = row;
    return detectOrderDates(hunterScheduledDate, null, hunterCloseDate, false);
  }
  if (key === 'accessoriesScheduledDate') {
    const {accessoriesScheduledDate, accessoriesOpenDate, accessoriesCloseDate} = row;
    return detectOrderDates(accessoriesScheduledDate, accessoriesOpenDate, accessoriesCloseDate, false);
  }
  if (key === 'pdsScheduledDate') {
    const {pdsScheduledDate, pdsOpenDate, pdsCloseDate} = row;
    return detectOrderDates(pdsScheduledDate, pdsOpenDate, pdsCloseDate, false);
  }
  if (key === 'pdsOpenDate') {
    const {pdsScheduledDate, pdsOpenDate, pdsCloseDate} = row;
    return detectOrderDates(pdsScheduledDate, pdsOpenDate, pdsCloseDate, false);
  }
  if (key === 'comboCode') {
    return `${row.comboCode}: ${row.comboName}`;
  }
  if (key.includes('Date')) {
    return value ? value.substring(0, 10) : value;
  }
  return value;
};


export const daysList = [
  {
    'key': '/',
    'value': '/',
    'text': 'TODOS',
  },
  {
    'key': '0|30',
    'value': '0|30',
    'text': '< 30',
  },
  {
    'key': '30|60',
    'value': '30|60',
    'text': '30 - 60',
  },
  {
    'key': '60|90',
    'value': '60|90',
    'text': '60 - 90',
  },
  {
    'key': '90|120',
    'value': '90|120',
    'text': '90 - 120',
  },
  {
    'key': '120|100000',
    'value': '120|100000',
    'text': '> 120',
  },
];


export const FilterDays = ({'column': {filterValue, setFilter, id}}) => {
  return (
    <>
      <Form.Select
        placeholder="Buscar..."
        fluid
        selection
        className='selector-tiny-size'
        value={filterValue}
        defaultValue=''
        onChange={(e, {value}) => setFilter(value)}
        options={daysList}
      />
    </>
  );
};

export const filterNumeric = (rows, id, filterValue) => {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    if (filterValue === '/') {
      return true;
    }
    const [min, max] = filterValue.split('|');
    if (rowValue >= parseInt(min, 10) && rowValue <= parseInt(max, 10)) {
      return true;
    }
    return false;
  });
};

